import { render, staticRenderFns } from "./Games.vue?vue&type=template&id=2e28e404&scoped=true"
import script from "./Games.vue?vue&type=script&lang=js"
export * from "./Games.vue?vue&type=script&lang=js"
import style0 from "./Games.vue?vue&type=style&index=0&id=2e28e404&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e28e404",
  null
  
)

export default component.exports